import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "unit"]
  static values = {
    remaining: Number,
    remainingUnit: String,
  }

  balance(event) {
    let value = this.remainingValue
    if (value === undefined || value === "") return

    if (this.hasUnitTarget && this.hasRemainingUnitValue) {
      value *= this.conversionFactor(
        this.remainingUnitValue,
        this.unitTarget.value
      )
    }

    this.inputTarget.value = value
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  conversionFactor(from, to) {
    if (from === to) return 1
    if (from === "kg" && to === "g") return 1000
    if (from === "g" && to === "kg") return 0.001

    return 1
  }
}
